import React, { Suspense } from 'react'
import ErrorBoundary from '../errorboundry'
import FallbackUI from '../fallbackUI'
import TransportationForm from './transportation'
import AdditionalInfo from './additionalInformation'
import PreviousDocuments from './prevDocument'
import HeaderLevelInfo from './HeaderLevelInfo';
import ErrorMessagesWindow from '@commonComponents/errorValidationWindow';
import RoutingCountries from './RoutingCountries'
import { useSelector } from 'react-redux';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import { useValidationCDS } from '../../hooks/useValidationCDS'
import { cdsFieldPatterns } from '../../util/cdsFieldPattern'


const HeaderForm = (props) => {

  const {isImportShipment,serviceType,isDisabled}=useCurrentShipmentType()
  const fieldPattern = cdsFieldPatterns(isImportShipment)

  const {validateError, updateError, initHeaderTabValidationCDS, initItemsTabValidationCDS} = useValidationCDS('header')

  const { isFormEnabled } = props
  const ErrorWarningsList = useSelector((state) => state.ErrorValidationReducer?.headerTab) || []
  const badge = props.currentJobData?.badge || ""

  return (
    <ErrorBoundary>
      {!props?.isServerErrorsCommon && ErrorWarningsList?.length > 0 && !props.disabled && (
            <ErrorMessagesWindow errors={ErrorWarningsList} />
          )}
        <div className='headerDetails formContentareaC88'>
          <HeaderLevelInfo 
            badge={badge} 
            isImportShipment={isImportShipment}
            fieldPattern={fieldPattern} 
            validateError={validateError}
            initHeaderTabValidationCDS={initHeaderTabValidationCDS}
            initItemsTabValidationCDS={initItemsTabValidationCDS}
            />
          <TransportationForm 
            isFormEnabled={isFormEnabled} 
            isImportShipment={isImportShipment}
            fieldPattern={fieldPattern} 
            validateError={validateError}
            />
          {serviceType === 'EX' && <RoutingCountries
           currentJobState={props.currentJobState}
          isFormDisabled={isDisabled} />}
          <AdditionalInfo isImportShipment={isImportShipment} />
          <PreviousDocuments />
        </div>
    </ErrorBoundary>
  )
}

export default React.memo(HeaderForm)
